import { ref } from '@vue/composition-api';
import { surveyService } from '@/bundles/Survey/factory/SurveyServiceFactory';
import { IQueryObjectParam } from '@/bundles/App/type';
import { ISurveyData } from '@/bundles/Survey/types';

export function useSurvey() {
  const surveys = ref<ISurveyData[]>([]);
  const total = ref(0);
  const pending = ref(false);
  const downloadLoading = ref(false);

  async function fetch(params: IQueryObjectParam[]) {
    pending.value = true;
    const { data, total: surveysTotal } = await surveyService.list(params);
    surveys.value = data;
    total.value = surveysTotal;
    pending.value = false;
  }

  async function exportToCsv(params: IQueryObjectParam[]) {
    downloadLoading.value = true;
    const link = await surveyService.exportToCsv(params);
    window.location.replace(link);
    downloadLoading.value = false;
  }

  return {
    surveys,
    total,
    pending,
    downloadLoading,
    fetch,
    exportToCsv,
  };
}